webpackJsonp([251083816312730],{

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fact1 = '/pdf/FACT SHEET 1_VIF_Indikator.pdf';
	var fact2 = '/pdf/FACT SHEET 2_VIF_Kriterien.pdf';
	var charta = '/pdf/Charta zur Vereinbarkeit von Familie und Beruf.pdf';
	
	var karten = [];
	for (var i = 2025; i >= 2016; i--) {
	  karten.push({
	    title: 'Karte VIF-Indikator inkl. Kooperationen ' + i + '/' + (i + 1 - 2000) + ' (PDF)',
	    link: '/pdf/Karte_VIF_Indikator_inkl_Koop_' + i + '_' + (i + 1) + '.pdf'
	  });
	}
	
	var FactBox = function FactBox() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'content-box' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'FactBox'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '1. Fact Sheets'
	    ),
	    _react2.default.createElement(
	      'h4',
	      { style: { color: '#be0021' } },
	      'VIF-Indikator \u2013 Information'
	    ),
	    'Mithilfe des sogenannten VIF-Indikators wird in \xD6sterreich jene mit der Vollbesch\xE4ftigung der Eltern zu verein\xADbarende, elementare Kinderbildung und -betreuung (\u201EVIF-Krite\xADrien\u201C) sichtbar gemacht.',
	    ' ',
	    _react2.default.createElement(
	      'a',
	      { target: '_blank', href: fact1 },
	      'Fact Sheet 1'
	    ),
	    _react2.default.createElement(
	      'h4',
	      { style: { color: '#be0021' } },
	      'VIF-Kriterien \u2013 Information'
	    ),
	    _react2.default.createElement(
	      'a',
	      { target: '_blank', href: fact2 },
	      'Fact Sheet 2'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '2. Dokumente'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { style: { listStyle: 'none', paddingLeft: '0' } },
	      karten.map(function (_ref) {
	        var link = _ref.link,
	            title = _ref.title;
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: link },
	            title
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: charta },
	          'Charta zur Vereinbarkeit von Familie und Beruf (PDF)'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          null,
	          'Brosch\xFCre Kinderbetreuungsatlas (PDF \u2013 nach Fertigstellung)'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.arbeiterkammer.at/service/studien/frauen/Wiedereinstiegsmonitoring.html' },
	          'Wiedereinstiegsmonitoring'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://bgld.arbeiterkammer.at/service/broschuerenundratgeber/akstudien/Unter_einem_hut.html' },
	          'Alles unter einen Hut'
	        )
	      )
	    )
	  );
	};
	
	exports.default = FactBox;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fact-box-js-165c43b327ea79ed02c8.js